<!--
<div>{{ title }} app is running!</div>
-->

<app-document-search></app-document-search>

